<template>
    <div
        :class="{ 'column no-wrap sot-page': true, 'absolute-full': $q.platform.is.mobile }"
        :style="{ 'overflow': 'hidden', 'height': $q.platform.is.mobile ? '' : 'calc(100vh - 40px)' }"
    >
        <!--
        :style="{ 'overflow': 'hidden', 'height': $q.platform.is.mobile ? 'calc(100vh - 80px)' : 'calc(100vh - 40px)' }"
        -->
        <slot />
        <div v-show="loading" class="col flex flex-center">
            <q-circular-progress indeterminate color="primary" size="sm" />
        </div>
        <div v-show="error" class="col column flex flex-center">
            <div class="items-center column q-gutter-y-md">
                <div>Страница не найдена</div>
                <div class="text-grey text-caption">{{ params }}</div>
                <q-btn label="Назад" @click="$pages.back()" no-caps />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BasePage',
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        error: {
            type: String,
            default: undefined,
        },
        params: {
            type: Object,
            default: undefined,
        },
    },
};
</script>

<style scoped>

</style>
